import { Handle, Position } from '@xyflow/react';
import configure from 'configure';
import { memo } from 'react';
import React from "react";

export const getInitials = (name = "") => {
  const trimmed = name.trim();

  // If the whole string is numeric or starts with number, return first "word" as-is
  if (/^\d+/.test(trimmed)) {
    return trimmed.split(" ")[0];
  }

  const words = trimmed.split(" ").filter(Boolean);

  if (words.length === 0) return "";
  if (words.length === 1) return words[0][0]?.toUpperCase() || "";

  return (words[0][0] + words[1][0]).toUpperCase();
};

function getTextonly(text = "") {
  return text.replace(/^\d+\s*/, "")
}
function AnnotationNode({ data }) {
  return (
    <>
      <Handle type="target" position={Position.Top} style={{ background: '#555' }} />
      {data?.show ? (
        <div style={{
          // border: '2px solid #a855f7',
          borderRadius: 6,
          background: 'white',
          minWidth: 150
        }}>
          <div className='d-flex align-items-center gap-2'>
            <div className='flex-1'>
              {data?.allData?.avatar ? (
                <img src={`${configure.imgUrl}/${data?.allData?.avatar}`} alt="" className="img-fluid object-fit-cover rounded-circle" width={25} height={25}
                  style={{ width: "25px", height: "25px", objectFit: "cover", borderRadius: "50%" }}
                />
              ) : (
                <div
                  className="defualt-img"
                  title={data?.value?.label}
                >
                  {getInitials(data?.value?.label)}
                </div>
              )}

            </div>
            <div className='text-start'>
              <p className='mb-0 font-size-11'><span className="text-purple fw-bold">{getTextonly(data?.value?.label)}</span> </p>
              {!data?.value?.__isNew__ ? (
                <span className='' style={{ fontSize: "9" }}>{data?.allData?.designation}</span>
              ) : null}
            </div>
          </div>
        </div >
      ) : (
        <div className="custom-node bg-white shadow  text-center">
          {data.label}
          <div
            className="mt-0"
            dangerouslySetInnerHTML={{ __html: data.htmlContent }}
          />
        </div>
      )
      }

      <Handle type="source" position={Position.Bottom} style={{ background: '#555' }} />
    </>
  );
}

export default memo(AnnotationNode);